import { MessageBox, Loading } from 'element-ui';
import { Report_promotion_service } from "./../services/Report_promotion_service";
import Cookie from "cookies-js"
import moment from "moment"
const { Parser } = require('json2csv');

const state = {
    user_id: null,
    provider_id: null,
    provider_type: null,
    provider_name: null,
    lists: [],
    details: null,
    prepares:[],
    histories: null,
    name: null,
    total: null,
    date_range: null,
    loading: false,
    download_form: null,
    fields_mobile : [{
        label: 'ผู้ให้บริการ',
        value: 'brand_name_th'
      }, {
        label: 'รหัสรายการส่งเสริมการขาย',
        value: 'promotion_code'
      }, {
        label: 'ชื่อรายการส่งเสริมการขาย',
        value: 'promotion_name_th'
      }, {
        label: 'จำนวนผู้เข้าชม',
        value: 'view_total'
      }, {
        label: 'ประเภทของการให้บริการ',
        value: 'promotion_category'
      }, {
        label: 'ราคา',
        value: 'promotion_price'
      }, {
        label: 'วันที่เริ่มขาย',
        value: 'start_sale_date'
      }, {
        label: 'วันสิ้นสุดการขาย',
        value: 'end_sale_date'
      }, {
        label: 'วันที่เริ่มให้บริการ',
        value: 'start_service_date'
      }, {
        label: 'วันสิ้นสุดการบริการ',
        value: 'end_service_date'
      }, {
        label: 'สถานะ',
        value: 'status'
      }, {
        label: 'วันที่อัปเดตล่าสุด',
        value: 'updated_at'
      }],
    fields_broadband : [{
        label: 'ผู้ให้บริการ',
        value: 'brand_name_th'
      }, {
        label: 'รหัสรายการส่งเสริมการขาย',
        value: 'promotion_code'
      }, {
        label: 'ชื่อรายการส่งเสริมการขาย',
        value: 'promotion_name_th'
      }, {
        label: 'จำนวนผู้เข้าชม',
        value: 'view_total'
      }, {
        label: 'ประเภทเทคโนโลยีของการให้บริการ',
        value: 'promotion_technology'
      }, {
        label: 'ราคา',
        value: 'promotion_price'
      }, {
        label: 'วันที่เริ่มขาย',
        value: 'start_sale_date'
      }, {
        label: 'วันสิ้นสุดการขาย',
        value: 'end_sale_date'
      }, {
        label: 'วันที่เริ่มให้บริการ',
        value: 'start_service_date'
      }, {
        label: 'วันสิ้นสุดการบริการ',
        value: 'end_service_date'
      }, {
        label: 'สถานะ',
        value: 'status'
      }, {
        label: 'วันที่อัปเดตล่าสุด',
        value: 'updated_at'
      }]
}

const actions = {

    async getTotalView({ commit }, data) {
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        if (data.isOper) {
            let provider_id =  await Report_promotion_service.getProviderTypeById(data.provider_id)
            data.provider_type = data.provider_type != null ? data.provider_type : provider_id.data.result[0].provider_type
        } else {
            data.provider_type = data.provider_type != null ? data.provider_type : 'mobile'
        }
        commit('SET_FORM_DOWNLOAD',data)
        let result = await Report_promotion_service.getTotalViewByType(data);
        if(result.status === 200){
            setTimeout(function(){ loadingInstance.close() }, 250);
            result.date_range = data.dateRange;
            commit('FETCH_TABLE', result)
            if(result.data.result.length != 0) {
                let count = result.data.result[0].total;
                commit('COUNTING', count)
            }
            setTimeout(function(){ loadingInstance.close() }, 250);
        }else{
            setTimeout(function(){ loadingInstance.close() }, 250);
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },

    async download_promotion({commit},data){
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        data.download = true
        let result = await Report_promotion_service.getTotalViewByType(data);
        if(result.status === 200){
            let download_data = result.data.result
            download_data.forEach(function(val, index){
                val.created_at = moment(val.created_at).add(543, 'y').format('DD/MM/YYYY')
                val.start_sale_date = moment(val.start_sale_date).format('DD/MM/YYYY') != 'Invalid date' ? moment(val.start_sale_date).add(543, 'y').format('DD/MM/YYYY') : ""
                val.end_sale_date = moment(val.end_sale_date).format('DD/MM/YYYY') != 'Invalid date' ? moment(val.end_sale_date).add(543, 'y').format('DD/MM/YYYY') : ""
                val.start_service_date = moment(val.start_service_date).format('DD/MM/YYYY') != 'Invalid date' ? moment(val.start_service_date).add(543, 'y').format('DD/MM/YYYY') : ""
                val.end_service_date = moment(val.end_service_date).format('DD/MM/YYYY') != 'Invalid date' ? moment(val.end_service_date).add(543, 'y').format('DD/MM/YYYY') : ""
                val.updated_at = moment(val.updated_at).add(543, 'y').format('DD/MM/YYYY')
                val.service_name = val.provider_short_name
            })
            let fields = data.provider_type == 'mobile' ? state.fields_mobile : state.fields_broadband
            CsvExport(download_data, fields, 'รายงานจำนวนผู้เข้าชมข้อมูลรายการส่งเสริมการขายจำแนกตามการให้บริการ')
            setTimeout(function(){ loadingInstance.close() }, 250);
        }else{
            setTimeout(function(){ loadingInstance.close() }, 250);
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },

    async get_provider_id({commit}){
        let json_cookie = JSON.parse(Cookie.get('user_nbtc'));
        let result = await Report_promotion_service.get_provider_id();
        if (result.status === 200) {
            commit('SET_PROVIDER_ID',result.data.result[0].company_provider_id)
            commit('SET_PROVIDER_TYPE', result.data.result[0].provider_type)
            commit('SET_USER_ID', json_cookie.admin_id)
        } else {
            MessageBox.confirm(result.message, 'ไม่พบ Company Provider ID', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    }
}

const mutations = {
    SET_PROVIDER_ID(state,id){
        state.provider_id = id
    },
    SET_PROVIDER_TYPE(state,type){
        state.provider_type = type != 'mobile' ? type : 'mobile'
    },
    SET_PROVIDER_NAME(state,name){
        state.provider_name = name
    },
    SET_USER_ID(state,id){
        state.user_id = id
    },
    FETCH_TABLE(state,obj){
        let promotion = obj.data.result
        state.lists = []
        let today = moment().format('DD/MM/YYYY');
        let date = obj.date_range ? moment(obj.date_range[0]).format('DD/MM/YYYY') : today;
        promotion.forEach(function(val, index){
            if(val.promotion_category) {
                val.promotion_technology = val.promotion_category
            }
            val.created_at = moment(val.created_at).add(543, 'y').format('DD/MM/YYYY')
            val.start_sale_date = moment(val.start_sale_date).format('DD/MM/YYYY') != 'Invalid date' ? moment(val.start_sale_date).add(543, 'y').format('DD/MM/YYYY') : ""
            val.end_sale_date = moment(val.end_sale_date).format('DD/MM/YYYY') != 'Invalid date' ? moment(val.end_sale_date).add(543, 'y').format('DD/MM/YYYY') : ""
            val.start_service_date = moment(val.start_service_date).format('DD/MM/YYYY') != 'Invalid date' ? moment(val.start_service_date).add(543, 'y').format('DD/MM/YYYY') : ""
            val.end_service_date = moment(val.end_service_date).format('DD/MM/YYYY') != 'Invalid date' ? moment(val.end_service_date).add(543, 'y').format('DD/MM/YYYY') : ""
            val.updated_at = moment(val.updated_at).add(543, 'y').format('DD/MM/YYYY')
            val.service_name = val.provider_short_name
        })
        state.lists = promotion
        state.total = promotion[0] ? promotion[0].total : 0
        state.loading = false
    },
    SET_FORM_DOWNLOAD(state, form){
        state.download_form = JSON.parse(JSON.stringify(form))
    },
    COUNTING(state,num){
        state.total = null
        state.total = num
    },
    SET_DATE_RANGE: (state, newValue) => {
        state.date_range = newValue
      },
}

let CsvExport = function(data, fields, fileName) {
    try {
      const parser = new Parser({fields});
      const result = parser.parse(data);
      var csvContent = 'data:application/vnd.ms-excel;csvcharset=GBK,\uFEFF' + encodeURIComponent(result)
      var link = document.createElement('a')
      link.setAttribute('href', csvContent)
      link.setAttribute('download', `${(fileName || 'file')}.xls`)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    } catch (err) {
      console.error(err)
    }
}

export const Report_view = {
    namespaced: true,
    state,
    actions,
    mutations
};